import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { baseUniDriverFactory } from '../../testkitUtils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';

import { modalDriverFactory } from '../internal/Modal/Modal.driver';

export interface CustomDialogDriver extends BaseUniDriver {
  isDialogOpen(): Promise<boolean>;
  childExists(predicate: string): Promise<boolean>;
}

export const customDialogDriverFactory = (
  base: UniDriver,
  body: UniDriver,
): CustomDialogDriver => {
  return {
    ...baseUniDriverFactory(base),

    /**
     *  Checks whether the dialog is open
     *  @returns {Promise<boolean>}
     */
    isDialogOpen: async () => {
      const modalDriver = modalDriverFactory(base, body);
      return modalDriver.isOpen();
    },

    /**
     * Checks whether a node with the provided predicate exist
     * @param {string} predicate - a predicate for the child node
     * @returns {Promise<boolean>}
     */
    childExists: async (predicate: string) => {
      const modalDriver = modalDriverFactory(base, body);
      return modalDriver.childExists(predicate);
    },
  };
};
